import { module } from 'constant'
import { createSelector } from 'selectors'

const {
	chart: { selector },
} = module

const getGraphicsContainerSelector = (scope: HTMLElement) =>
	createSelector<HTMLElement>({ selector: selector.graphicsContainer, scope })

export const getChartSelectors = {
	graphicsContainer: getGraphicsContainerSelector,
}
